import React from "react";

import {
  Box,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

import { Organisation, User } from "../../../types";
import { getTeamRoleInfo } from "../../../utils/get-team-role-info";
import TeamChip from "../../../components/chips/team-chip";
import RoleChip from "../../../components/chips/role-chip";

interface TeamsCardProps {
  user: User; // only useful for getting the role of the user in each team
  teams: Organisation[];
}

const TeamsCard: React.FC<TeamsCardProps> = ({ user, teams }) => {
  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="h4">Teams</Typography>
          <Divider />

          {teams.length > 0 ? (
            <Stack spacing={1.5}>
              {teams.map((team) =>
                team ? (
                  <Box
                    key={team.organisationId}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 1.5,
                    }}
                  >
                    <TeamChip
                      teamId={team.organisationId}
                      name={team.name}
                      color={team.color}
                    />
                    <RoleChip
                      role={getTeamRoleInfo(user, team.organisationId)}
                    />
                  </Box>
                ) : null,
              )}
            </Stack>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Not part of any teams
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default TeamsCard;
